// @ts-ignore
import s from './LocationModal.module.scss'
import { Button } from '@corratech/pylot-ui'
import cn from 'classnames'

import { useTranslation } from 'next-i18next'
import dynamic from 'next/dynamic'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import Cookies from 'js-cookie'
import { useLocationCountryDetail } from './hooks/useLocationCountryDetail'

/**
 * Is used to query element by id and get navbar's height as an offset
 * when scrolling to the target element.
 */

const LocationModal = ({
    setShowLocationModal,
    showLocationModal
}: {
    setShowLocationModal: Dispatch<SetStateAction<boolean>>
    showLocationModal: boolean
}) => {
    const Modal = dynamic(() => import('@corratech/pylot-ui/src/Modal'))
    const { t } = useTranslation('common')
    const router = useRouter()
    const baseStoreCode = process.env.NEXT_PUBLIC_STORE_CODE
    const currentCountry = Cookies.get('x-pylot-country') ?? ''
    const { countryDetail, currentLocationDetail } = useLocationCountryDetail()

    const [selectedCountryData, setselectedCountryData] = useState(
        countryDetail[0]
    )
    useEffect(() => {
        if (currentCountry) {
            const currentCountryData = countryDetail.find(
                (data) => data.code === currentCountry
            )
            if (
                currentCountryData &&
                currentCountryData.storeCode !== baseStoreCode &&
                !localStorage.getItem('location_dropdown_closed')
            ) {
                setShowLocationModal(true)
                setselectedCountryData(currentCountryData)
            }
        }
    }, [currentCountry])

    if (!showLocationModal) return null

    return (
        <div className={cn(s.root, s['location-block'])}>
            <Modal
                open={showLocationModal}
                onClose={() => {
                    setShowLocationModal(false)
                    localStorage.setItem('location_dropdown_closed', '1')
                }}
                className={s['location-popup']}
            >
                <div className={s['location-container']}>
                    <form className={s['location-form']}>
                        <div className="form-group">
                            <label className="heading" htmlFor="continent">
                                {t('Choose your Country')}
                            </label>
                            {/* eslint-disable-next-line jsx-a11y/no-onchange */}
                            <select
                                className="form-select"
                                onChange={(e) => {
                                    setselectedCountryData(
                                        countryDetail.find(
                                            (data) =>
                                                data.code === e.target.value
                                        )!
                                    )
                                }}
                            >
                                {countryDetail.map(
                                    ({ code, country, disabled }) => {
                                        if (!disabled) {
                                            return (
                                                <option
                                                    key={country}
                                                    value={code}
                                                    selected={
                                                        selectedCountryData.code ===
                                                        code
                                                    }
                                                >
                                                    {country}
                                                </option>
                                            )
                                        }
                                    }
                                )}
                            </select>
                        </div>
                        <Button
                            type="button"
                            /* eslint-disable-next-line i18next/no-literal-string */
                            data-variant="link"
                            className="btn-neutral"
                            onClick={() => {
                                router.push(selectedCountryData.url)
                                localStorage.setItem(
                                    'location_dropdown_closed',
                                    '1'
                                )
                                setShowLocationModal(false)
                            }}
                        >
                            {t('Submit')}
                        </Button>
                    </form>
                </div>
            </Modal>
        </div>
    )
}

export default LocationModal
